const _0 = "0"
const _1 = "1px"
const _2 = "2px"
const _3 = "3px"
const _4 = "4px"
const config = { "0": _0, "1": _1, "2": _2, "3": _3, "4": _4,  }
export { config as default, _0, _1, _2, _3, _4 }